"use client"

import { useState } from "react"
import { NavLink } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import {
  Search,
  FileText,
  LogOut,
  UserCog,
  ChevronDown,
  ChevronUp,
  Menu,
  icons,
  Home
} from "lucide-react"

export default function Sidebar() {
  const { user, logout } = useAuth()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({})

  const adminMenuItems = [
    {
      category: "Home",
      icons: icons.Home,
      items: [{ path: "/dashboard/center", icon: Home, label: "Home" }],
    },
    {
      category: "Administrator",
      icons: icons.User,
      items: [{ path: "/dashboard/web-users", icon: UserCog, label: "web user" }],
    },
  ]

  const userMenuItems = [
    {
      category: "Home",
      icons: icons.Home,
      items: [{ path: "/dashboard/center", icon: Home, label: "Home" }],
    },
    {
      category: "Customer",
      icons: icons.Search,
      items: [{ path: "/dashboard/customer-search", icon: Search, label: "Customer Search" }],
    },
    {
      category: "Reports",
      icons: icons.FileText,
      items: [{ path: "/dashboard/summary-report", icon: FileText, label: "Summary" }],
    },
  ]

  const menuItems = user?.Role === "admin" ? adminMenuItems : userMenuItems

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev)
  }

  const toggleSection = (category: string) => {
    setOpenSections((prev) => ({
      ...prev,
      [category]: !prev[category],
    }))
  }

  return (
    <div
      className={`h-screen flex flex-col bg-gray-100 transition-all duration-300 ${
        isCollapsed ? "w-14" : "w-48"
      }`}
    >
      {/* Toggle Sidebar Button */}
      <div className="p-2 bg-[#004261] border-b flex justify-end">
        <button
          onClick={toggleSidebar}
          className="text-white hover:bg-[#003044] p-1 rounded"
        >
          <Menu size={18} />
        </button>
      </div>

      {/* User Info */}
      {!isCollapsed && (
        <div className="p-2 bg-[#004261]  border-b">
          {/* <div className="text-[10px] font-bold text-black mb-1">USER NAME:</div> */}
          <div className="text-[14px] font-bold italic text-white">
         Welcome,   {user?.Name?.toUpperCase()} <br></br> 
          </div>
        </div>
      )}

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-2">
        {menuItems.map((category, idx) => {
          const isOpen = openSections[category.category] ?? true
          const Icon = category.icons

          return (
            <div key={idx} className="mb-1">
              {/* Section Header */}
              <div
                className="flex items-center justify-between px-2 bg-[#004261] text-white text-[10px] font-bold py-1 cursor-pointer hover:bg-[#003044]"
                onClick={() => toggleSection(category.category)}
              >
                <div className="flex items-center gap-2">
                  <Icon className="h-4 w-4" />
                  {!isCollapsed && <span className="truncate">{category.category}</span>}
                </div>

                {!isCollapsed &&
                  (isOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />)}
              </div>

              {/* Submenu Items */}
              {isOpen && (
                <div className={`mt-1 ${isCollapsed ? "px-1" : "ml-2"}`}>
                  {category.items.map((item) => (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      className={({ isActive }) =>
                        `flex items-center px-2 py-1 text-[10px] mb-1 transition-colors border-l-2 ${
                          isActive
                            ? "bg-blue-100 text-blue-800 border-blue-600"
                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400"
                        }`
                      }
                    >
                      <item.icon className="h-3 w-3 mr-1 flex-shrink-0" />
                      {!isCollapsed && <span className="truncate">{item.label}</span>}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          )
        })}
      </nav>

      {/* Logout Button */}
      <div className="p-1">
        <button
          onClick={logout}
          className="w-full bg-[#004261] text-white text-[10px] font-bold px-2 py-1 hover:bg-[#00283b] transition-colors"
        >
          <div className="flex items-center justify-center">
            <LogOut className="h-3 w-3 mr-1" />
            {!isCollapsed && "Sign out"}
          </div>
        </button>
      </div>
    </div>
  )
}
